module.exports = __webpack_public_path__ + "img/背景.92902ccf.jpg";